<template>
  <el-dialog custom-class="max-dialog" title="人员信息" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>基本信息</span>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="姓名" :label-width="formLabelWidth">
                {{form.uname}} {{form.mobile}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门" :label-width="formLabelWidth">
                {{form.dname}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职务" :label-width="formLabelWidth">
                {{form.mainusernames}} {{form.otherusernames}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="办公电话" :label-width="formLabelWidth" prop="officetel">
                <el-input v-model="form.officetel" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="毕业院校" :label-width="formLabelWidth" prop="byyx">
                <el-input v-model="form.byyx" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学历" :label-width="formLabelWidth" prop="xl">
                <el-select v-model="form.xl" placeholder="请选择">
                  <el-option
                    v-for="item in controlData.xl"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="性别" :label-width="formLabelWidth" prop="sex">
                <el-radio-group v-model="form.sex">
                  <el-radio v-for="item in controlData.sex" :label="item.value" :key="item.value">{{item.text}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生日期" :label-width="formLabelWidth" prop="birsday">
                <el-date-picker style="width:100%"
                                v-model="form.birsday" :value-format="'yyyy-MM-dd'"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号" :label-width="formLabelWidth" >
                <el-input v-model="form.sfzh" auto-complete="off" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <span>薪资信息</span>
          </template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="工资标准" :label-width="formLabelWidth" prop="gdsalary">
               {{form.gdsalary}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工资卡所属银行" :label-width="formLabelWidth" prop="bankname">
                {{form.bankname}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工资卡号" :label-width="formLabelWidth" prop="bankid">
                {{form.bankid}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="社保卡号" :label-width="formLabelWidth" prop="sbkh">
                {{form.sbkh}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="社保基数" :label-width="formLabelWidth" prop="sbjs">
                {{form.sbjs}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="公积金卡号" :label-width="formLabelWidth" prop="sbkh">
                {{form.gjjzh}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公积金基数" :label-width="formLabelWidth" prop="sbkh">
                {{form.gjjjs}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updateSelf, getDetail, getControlData} from '@/api/set/employee';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        activeNames: ['1', '2', '3', '4'],
        form: {  //表单数据
          uname: '',
          sfzh: '',
          sex: '0',
          gh: '',
          birsday: '',
          rzrq: '',
          byyx: '',
          xl: '',
          dserial: '',
          dname: '',
          mainuserguids: '',//岗位主职
          mainusernames: '',//岗位主职
          otheruserguids: '',//岗位副职
          otherusernames: '',//岗位副职
          mobile: "",
          officetel: "",
          eMail: '',
          salarymode: 2,
          gdsalary: '',
          bankid: '',
          bankname: '',
          salarygroup: '',
          sbkh: '',
          gjjzh: '',
          gjjjs: '',
          paystyle: '1',
          uguid: '',
          status: 2,
        },
        controlData: {//绑定的控件数据，例如下拉框、复选框，单选按钮组等。
          xl: [],
          salarymode: [],
          paystyle: [],
          salarygroup: [],
          sex: [],
          status: [],
          enabled: []
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
        },
      }
    },
    methods: {
      changeStatus(data) {
      },
      show(dserial,dname) {
        if(dserial) {
          this.form.dname = dname
          this.form.dserial = dserial
        }
        this.dialogFormVisible = true;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable = true;
            updateSelf(this.form).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
              } else {
                this.$message.error(response.data.msg);
              }
              //
              this.isDisable = false;
            });
          }
        })
      },

      initData(uguid) {
        this.initForm()
        getDetail({uguid: uguid}).then(response => {
          for (let i in  this.form) {
            this.form[i]= response.data.obj[i];
          }
        })
      },
      initForm() {

      }
    },
    mounted() {
      getControlData().then(response => {
        this.controlData = response.data.obj
      })

    },
    components: {

    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/set/employee/MyEdit.vue